import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col } from "react-bootstrap"
import Layout from './components/Layout';
import Content from './components/Content';
import Maintenance from './components/Content/Maintenance';
import { ReactNotifications } from 'react-notifications-component';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <div className="container-fluid">
      <ReactNotifications />
      <Row className="justify-content-center">
        <Col>
          <BrowserRouter>
            <Routes>
              <Route path="/billpayments" element={<Layout/>}>
                <Route index element={<Content />} />
                <Route path="maintenance" element={<Maintenance />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </Col>
      </Row>
    </div>
  );
}

export default App;
